import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { BzObjType } from '../Enums/BzObjType.enum';
import { EMode } from '../Enums/EMode.enum';

export class BatchBillingServiceContractsRequest<
  T extends EMode = EMode.entity
> {
  /** Alias: codes */
  codes?: any[];
  /** Alias: dueDate */
  dueDate?: any;
  /** Alias: invoiceDate */
  invoiceDate?: any;
  /** Alias: accountingDate */
  accountingDate?: any;
  /** Alias: bzObjType */
  bzObjType?: BzObjType;

  __typename?: string;
}

const fields: FieldDefinitions<BatchBillingServiceContractsRequest> = {
  codes: {
    alias: 'codes',
  },
  dueDate: {
    alias: 'dueDate',
  },
  invoiceDate: {
    alias: 'invoiceDate',
  },
  accountingDate: {
    alias: 'accountingDate',
  },
  bzObjType: {
    alias: 'bzObjType',
  },
  __typename: {
    alias: '__typename',
  },
};

export const batchBillingServiceContractsRequestEntityDefinition: EntitiyDefinition<BatchBillingServiceContractsRequest> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'BatchBillingServiceContractsRequest',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
